<!-- <div class="logo-des">
    <img src="./assets/media/icons/png/FieldProLogowebform.png" alt="My Image">
</div> -->

<form id="form_body" [formGroup]="Facility" novalidate="" class="custom-forms form-horizontal">
    <!-- <div class="modal-body container"> -->
        <!-- <h4>{{'CYRIX.FACINFO' | translate}}</h4>
        <br>
        <br> -->
        <!-- <div class="row formparentRow">
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'CYRIX.FACNAME' | translate}}<label
                            class="errorcolor">*</label></label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="facilityname" class="form-control" name="facilityname" id="facilityname" readonly />
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'CYRIX.FACNATURE' | translate}}<label
                            class="errorcolor">*</label></label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="facilitynature" class="form-control" name="facilitynature" id="facilitynature" readonly />
                    </div>
                </div>
            </div>
        </div>
        <div class="row formparentRow">
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'CYRIX.MOBNUM' | translate}}<label
                            class="errorcolor">*</label></label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="contactnumber" class="form-control" name="contactnumber" id="contactnumber" readonly />
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-6">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'CYRIX.EMAIL' | translate}}<label
                            class="errorcolor">*</label></label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="email_id" class="form-control" name="email_id" id="email_id" readonly />
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row formparentRow">
            <div class="col-sm-4 col-md-4">
                <div class="row">
                    <div class="col-sm-5 col-md-5">
                        <label class="control-label centeredlabel">{{'CUSTOMER.ENTER' | translate}} {{'CYRIX.BARCODE' | translate}}</label>
                    </div>
                    <div class="col-sm-7 col-md-7">
                        <input type="text" formControlName="barcode" (keypress)="numberOnly($event)" minlength="8" maxlength="8" class="form-control" name="barcode" id="barcode" placeholder="Enter Barcode">
                    </div>
                </div>
            </div>
            <div class="col-sm-3 col-md-3">
                <button class="btn btnFill" (click)="searchBarCode()">Go</button>&nbsp;
                <button class="btn btnFill" (click)="reset()">Reset</button>
            </div>
        </div>

    <!-- </div> -->
</form>
        <div class="row">
            <div id="tables" class="table-responsive GeneralTable text-nowrap">
                <table datatable="ng" *ngIf="showTable" class="table-bordered datatable w-auto mw-100" [dtOptions]="dtOptions">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{'CYRIX.BARCODE' | translate}}</th>
                            <th>{{'CYRIX.PRODGRP' | translate}}</th>
                            <th>{{'CYRIX.DEVGROUP' | translate}}</th>
                            <th>{{'CYRIX.DEVMAKE' | translate}}</th>
                            <th>{{'CYRIX.DEVMODEL' | translate}}</th>
                            <th>{{'CYRIX.DEVCLASS' | translate}}</th>
                            <!-- <th>{{'CYRIX.CONTRACTID' | translate}}</th> -->
                            <th>{{'CYRIX.EXDATE' | translate}}</th>
                            <th>{{'NEW_SUBSCRIPTION.ACTION' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="product_details?.length > 0">
                        <tr *ngFor="let product of product_details; let i = index;">
                            <td>{{i+1}}</td>
                            <td>{{product.serial_no}}</td>
                            <td>{{product.product.product_name}}</td>
                            <td>{{product.sub_product.product_sub_name}}</td>
                            <td>{{product.model_no}}</td>
                            <td>{{product.part_number}}</td>
                            <td>{{product.facility_device_class}}</td>
                            <!-- <td class="datacolor">{{product.contract_id}}</td> -->
                            <td *ngIf="product.expiry_day != null ">{{product.expiry_day}}</td>
                            <td  style="text-align: center;" *ngIf="product.expiry_day == null ">-</td>
                            <td>
                                <button *ngIf="product.ticket_base == 'No' " type="button" class=" btn-pill btn-sm custom-btn ml-2 disabledsubmit successbtn padbut" (click)=raisecomplaint(product)>Raise Ticket</button>
                                <button style="margin-left: 0.6rem;" *ngIf="product.ticket_base == 'Yes' " type="button" class="btn-outline colorwhite padbut">Open Ticket</button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="product_details?.length == 0">
                        <tr>
                            <td colspan="10" style="text-align: center;">No Records Found</td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>


<!-- <div class="row">
    <kt-productlist [product_details]="product_list"></kt-productlist>
</div> -->